<template>
    <!--
        latestImageIdとunsavedPuriCountはこのheader,footerタイプの組み合わせだと必要ないが
        BaseLayoutの設計上必須propsにしているので、ダミーの値を渡している
    -->
    <base-layout
        :header-type="headerType.LOGOONLY"
        :footer-type="footerType.COPYRIGHTONLY"
        latest-image-id="dummy"
        unsaved-puri-count="0"
    >
        <div class="c-jhs-free-input-profile">
            <jhs-free-heading/>
            <template v-if="!isChange">
                <div class="l-element">
                    <p class="c-jhs-free-input-profile-stepnavi"><img :src="buildImageUrl('/img/jhs_free/stepnavi_01.png')"
                                                                      alt="STEP1 申込情報入力"></p>
                </div>
                <heading-bg title="申込情報の入力"/>
                <div class="l-element is-pdb0">
                    <p class="m-text-normal is-primary is-text-center is-text-bold">全ての項目を正確に入力してね！</p>
                </div>
                <div class="l-element">
                    <p class="m-text-normal">申し込み情報を入力して次へボタンを押してください。</p>
                    <list-text :comments="true">
                        <li class="m-list-text-item">{{ noticeText }}</li>
                    </list-text>
                </div>
            </template>
            <template v-else>
                <div class="l-element is-pdb0">
                    <p class="m-text-normal is-primary is-text-center is-text-bold">注意してね！</p>
                </div>
                <div class="l-element">
                    <p class="m-text-normal">{{ noticeText }}</p>
                </div>
                <heading-bg title="申込情報の変更"/>
            </template>

            <div class="is-mgb8">
                <!--名前-->
                <jhs-free-input-profile-item-user-name
                    :is-empty-family-name="isEmptyFamilyName"
                    :is-empty-given-name="isEmptyGivenName"
                    :is-include-symbols="isNameIncludeSymbols"
                    :family-name-value="familyName"
                    :given-name-value="givenName"
                    :blur-func="validateFullName"
                    @inputFamilyName="updateFamilyNameFunc"
                    @inputGivenName="updateGivenNameFunc"
                />
                <!--生年月日-->
                <div class="c-date-of-birth is-mgt8">
                    <heading-form-label text="生年月日" label="required"/>
                    <input-profile-item-date-of-birth
                        :year-value="birthYear"
                        :month-value="birthMonth"
                        :day-value="birthDay"
                        :start-year="startYear"
                        :end-year="endYear"
                        :error-text="errorText"
                        @input="updateDateOfBirth"
                    />
                </div>
                <!--学年-->
                <jhs-free-input-profile-item-grade
                    :grade-value="grade"
                    :error-text="gradeErrorText"
                    @input="updateGradeFunc"
                />

                <!--メールアドレス-->
                <jhs-free-input-profile-item-mail-address
                    :value="mailAddress || ''"
                    :is-valid-mail-address="isValidMailAddress"
                    @input="updateAddress"
                />
            </div>
            <div class="l-element">
                <btn v-if="isChange" :priority="switchButton" text="この内容で保存する"
                     :is-router-link="true" link="/confirm/last" data-jest="save-btn"/>
                <btn v-else :priority="switchButton" text="次へ"
                     data-jest="next-btn" @click="nextPage"/>
            </div>
        </div>
    </base-layout>
</template>

<script>
import BaseLayout from "../../templates/BaseLayout.vue";
import * as metaInformationUtil from "../../../util/metaInformationUtil.js";
import JhsFreeHeading from "../../molecules/JhsFreeHeading.vue";
import HeadingBg from "../../atoms/HeadingBg.vue";
import ListText from "../../atoms/ListText.vue";
import Btn from "../../atoms/Btn.vue";
import {cssPriority} from "../../../view-model/enum/CSSPriority";
import {mapActions, mapGetters} from "vuex";
import JhsFreeInputProfileItemUserName from "../../molecules/JhsFreeInputProfileItemUserName.vue";
import InputProfileItemDateOfBirth from "../../molecules/InputProfileItemDateOfBirth.vue";
import JhsFreeInputProfileItemMailAddress from "../../molecules/JhsFreeInputProfileItemMailAddress.vue";
import JhsFreeInputProfileItemGrade from "../../molecules/JhsFreeInputProfileItemGrade.vue";
import * as formValidateUtil from "../../../util/FormValidateUtil";
import {headerType} from "../../../view-model/enum/HeaderType";
import {footerType} from "../../../view-model/enum/FooterType";
import * as urlUtil from "../../../util/UrlUtil";
import HeadingFormLabel from "../../atoms/HeadingFormLabel.vue";
import {SchoolGradeUtil as schoolGradeUtil} from "../../../util/SchoolGradeUtil";
import Modal from "../../molecules/Modal.vue";
import HeadingSection from "../../atoms/HeadingSection.vue";
import {getGa4EventLabel} from "../../../util/Ga4EventUtil";

export default {
    name: "JhsFreeInputProfile",
    components: {
        HeadingSection,
        Modal,
        BaseLayout,
        JhsFreeInputProfileItemMailAddress,
        InputProfileItemDateOfBirth,
        JhsFreeInputProfileItemUserName,
        JhsFreeInputProfileItemGrade,
        Btn,
        ListText,
        HeadingBg,
        JhsFreeHeading,
        HeadingFormLabel
    },
    props: {
        /**
         * titleタグ
         */
        title: {
            type: String,
            required: true
        },
        /**
         * meta description
         */
        description: {
            type: String,
            required: true
        },
        /**
         * 変更ページか
         */
        isChange: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            headerType: headerType,
            footerType: footerType,
            cssPriority: cssPriority,
            isEmptyFamilyName: false,
            isEmptyGivenName: false,
            isNameIncludeSymbols: false,
            noticeText: "情報の入力の途中でブラウザの「閉じる×」や「戻る」ボタンを押した場合、入力した内容が消えてしまう場合があるのでご注意ください。",
            now: new Date(),
        }
    },
    computed: {
        ...mapGetters({
            familyName: 'JhsFreeStore/familyName',
            givenName: 'JhsFreeStore/givenName',
            birthYear: 'JhsFreeStore/birthYear',
            birthMonth: 'JhsFreeStore/birthMonth',
            birthDay: 'JhsFreeStore/birthDay',
            grade: 'JhsFreeStore/grade',
            mailAddress: 'JhsFreeStore/mailAddress',
            accountStatus: 'AccountStoreV2/accountStatus',
        }),
        thisYear() {
            return this.now.getFullYear()
        },
        /**
         * 今年度の中学生の生年月日の下限
         * @returns {number}
         */
        startYear() {
            return schoolGradeUtil.getSchoolYear(this.now) - 15
        },
        /**
         * 今年度の中学生の生年月日の上限
         * @returns {number}
         */
        endYear() {
            return this.startYear + 3
        },
        /**
         * 入力された生年月日を返す
         * @returns {Date}
         */
        birthdate() {
            if (this.birthYear && this.birthMonth && this.birthDay) {
                return new Date(this.birthYear, this.birthMonth - 1, this.birthDay)
            } else {
                return null;
            }
        },
        /**
         * 入力された生年月日が今年度の中学生かどうか
         */
        isJhsStudent() {
            if (this.birthdate) {
                return !!schoolGradeUtil.getJhsGrade(this.birthdate, this.now);
            } else {
                return false
            }
        },
        /**
         * 申込受付終了期間であるか判定する
         * @returns {boolean}
         */
        isInTermOfThirdGradeEndOfEntry() {
            return this.accountStatus.timeTripDate.isInTime(`${this.thisYear}-02-21T00:00:00`, `${this.thisYear}-04-01T00:00:00`)
        },
        /**
         * 入力された生年月日が今年度の中学3年かどうか
         */
        isThirdGrade() {
            if (this.birthdate) {
                return schoolGradeUtil.getJhsGrade(this.birthdate, this.now) === 15
            } else {
                return false
            }
        },
        /**
         * エラーテキスト
         */
        errorText() {
            if (this.birthdate && !this.isJhsStudent) {
                return "今回のサービスの対象学年ではありません"
            } else if (this.isInTermOfThirdGradeEndOfEntry && this.isThirdGrade) {
                return `${schoolGradeUtil.getSchoolYear(this.now)}年度中3の申込受付は終了しました`
            }
        },
        /**
         * 入力された生年月日と選択した学年が一致しているか
         */
        isCorrectGrade() {
            if (this.birthdate && this.grade) {
                return schoolGradeUtil.isMatchingGrade(this.birthdate, this.now, this.grade)
            } else {
                return false
            }
        },
        /**
         * 学年選択のエラーテキスト
         */
        gradeErrorText() {
            // 生年月日未入力かつ学年未選択時は特にバリデーションチェックは実施しない
            if (this.birthdate && this.grade) {
                if(!this.isCorrectGrade){
                    return "入力した生年月日と学年が一致しません。正しい情報をご入力ください"
                }
            }
        },
        /**
         * 有効なメールアドレス形式か判定する
         */
        isValidMailAddress() {
            return formValidateUtil.isValidMailAddress(this.mailAddress)
        },
        /**
         * バリデーションエラーの有無によってボタンの活性/非活性を切り替える
         */
        switchButton() {
            const isRequiredFieldFilled = this.familyName && this.givenName && !this.isEmptyFamilyName &&
                this.birthYear && this.birthMonth && this.birthDay && this.mailAddress;
            const isValid = !this.isNameIncludeSymbols &&
                this.isValidMailAddress &&
                !this.isEmptyGivenName &&
                this.isJhsStudent &&
                !(this.isInTermOfThirdGradeEndOfEntry && this.isThirdGrade) &&
                this.isCorrectGrade;
            if (isRequiredFieldFilled && isValid) {
                return cssPriority.PRIMARY;
            } else {
                return cssPriority.DISABLED;
            }
        },
    },
    methods: {
        ...mapActions('JhsFreeStore', [
            'updateFamilyName', 'updateGivenName', 'updateBirthYear', 'updateBirthMonth', 'updateBirthDay', 'updateGrade', 'updateMailAddress'
        ]),
        /**
         * 名前の入力値をチェックする
         * 空、記号を許容しない
         */
        validateFullName() {
            // 空かどうかの判定
            this.isEmptyFamilyName = !this.familyName.trim()
            this.isEmptyGivenName = !this.givenName.trim()
            // 記号かどうかの判定
            this.isNameIncludeSymbols = this.isIncludingSymbols(this.familyName + this.givenName)
        },

        /**
         * 入力値に記号が含まれているか判定する
         */
        isIncludingSymbols(value) {
            const reg = new RegExp(/[!"#$%&'()\*\+\-\.,\/:;<=>?@\[\\\]^_`{|}~]/g);
            return reg.test(value);
        },
        setTitleAndDesc() {
            metaInformationUtil.setTitleAndDescription(this.title, this.description)
        },
        /**
         * JhsFreeInputProfileItemUserName.vueからもらった姓をstoreに格納し、
         * バリデーションチェックをする
         */
        updateFamilyNameFunc(familyName) {
            this.updateFamilyName(familyName)
            this.validateFullName()
        },
        /**
         * JhsFreeInputProfileItemUserName.vueからもらった名をstoreに格納し、
         * バリデーションチェックをする
         */
        updateGivenNameFunc(givenName) {
            this.updateGivenName(givenName)
            this.validateFullName()
        },
        /**
         * JhsFreeInputProfileItemDateOfBirth.vueからもらった生年月日をstoreに格納し、
         * バリデーションチェックをする
         */
        updateDateOfBirth(...args) {
            const [year, month, day] = args;
            this.updateBirthYear(year);
            this.updateBirthMonth(month);
            this.updateBirthDay(day);
        },
        /**
         * 入力されたメールアドレスが有効な場合はその値を、無効な場合はnullを引数として受け取る
         * 入力値自体も子から受け取ったものをstoreに格納する
         */
        updateAddress(value) {
            this.updateMailAddress(value)
        },
        /**
         * 入力された学年情報から、gradeを更新し、バリデーションチェックをする
         * 値をStoreに格納する
         */
        updateGradeFunc(value) {
            this.updateGrade(value)
        },
        /*
        * VOYAGERFRONT-6111 LINEイベントコード設置
        * ユニテのため切り出している
        */
        sendLineTag() {
            _lt('send', 'cv', {
                type: 'event2'
            }, ['00959236-1b74-4654-8bc6-3b291d37ee67']);
        },
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.buildS3ImageUrl('img/jhs-free/lp/' + imgName)
        },
        buildImageUrl(url)  {
            return urlUtil.imageUrlUtil.buildImageUrl(url)
        },
        nextPage() {
            if (this.switchButton === cssPriority.PRIMARY) {
                getGa4EventLabel('TAP_BUTTON', 'JHS_FREE_INPUT_PROFILE');
                this.$router.push('/input/certificate');
            }
        }
    },
    mounted() {
        // 広告タグ送信
        this.sendLineTag();

        if (this.accountStatus && this.accountStatus.timeTripDate) {
            this.now = this.accountStatus.timeTripDate.nowDateTime.toDate()
        }
    },
}
</script>

<style scoped lang="scss">
@use "sass:math";
// 基本の余白
$grid-base: 4.27vw; // 375px幅に対して16px
$grid-consistent: $grid-base * 0.5; // 375px幅に対して8px

.c-jhs-free-input-profile {
    margin-bottom: $grid-consistent * 3;

    &-stepnavi {
        width: percentage(math.div(236px, 343px));
        margin: 0 auto;
    }

    .c-jhs-free-lp-video {
        width: 100%;
        height: auto;
    }
}

.c-date-of-birth {
    padding: 0 $grid-consistent $grid-consistent;
}
</style>
